module.exports = __webpack_public_path__ + "img/huoshan@2X.743d9bfa.png";